import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private router: Router
  ) {
    if (!this.loginService.hasToken()) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit(): void {
    this.loginService.scheduleRefresh();
  }

}
